import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from 'src/app/core/helpers/core.service';
@Component({
  selector: 'loyaltic-scan',
  templateUrl: './scan.component.html',
  styleUrls: ['./scan.component.scss']
})
export class ScanComponent implements OnInit, OnDestroy {
  scanningState: string;

  @Input() scanningData: string[] = [];
  showScanningData: boolean[] = [];
  private readonly SCANNING_DELAY = 100; // milliseconds
  private readonly SCANNING_DURATION = 7000; // milliseconds
  private readonly INTERVAL_DURATION = 1000; // milliseconds
  
  constructor(private router: Router, private coreService: CoreService) {
    
  }

  ngOnInit() {
    document.querySelector('body').classList.add('body-scanning');
    this.scanningState = null; // Reset the state
    setTimeout(() => {
      this.scanningState = 'scanning';
      this.coreService.responseLoadedEmitter.subscribe((response: any) => {
        this.startInterval();
        setTimeout(() => {
          this.completeScanning();
        }, this.SCANNING_DURATION);
      });
      
    }, this.SCANNING_DELAY); // Delay for resetting state
  }
  ngOnDestroy() {
    document.querySelector('body').classList.remove('body-scanning');
  }
  startInterval() {
    let index = 0;
    const intervalId = setInterval(() => {
      this.showScanningData[index] = true;

      if (index > 0) {
        this.showScanningData[index - 1] = false;
      }

      index++;

      if (index >= this.scanningData.length) {
        clearInterval(intervalId);
      }
    }, this.INTERVAL_DURATION);
  }


  completeScanning() {
    this.scanningState = 'completed';
    this.router.navigate(['scan/success']);
    console.log('state:' + this.scanningState)
  }
}
